<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title16"></a>
<div class="toc_entry"><a class="toc_entry_frontMatter" href="#/9781459271517_fm01"><span><strong class="b">“You Don’t Have To Pay Me Back,”</strong></span></a><br/>
<a class="toc_entry_frontMatter" href="#/9781459271517_fm02"><span>Letter to Reader</span></a><br/>
<a class="toc_entry_titlePage" href="#/9781459271517_tp01"><span>Title Page</span></a><br/>
<a class="toc_entry_alsoby" href="#/9781459271517_als01"><span>Books by Elizabeth Beverly</span></a><br/>
<a class="toc_entry_aboutAuthorPage" href="#/9781459271517_ata01"><span>About the Author</span></a><br/>
<a class="toc_entry_dedicationPage" href="#/9781459271517_ded01"><span>Dedication</span></a><br/>
<a class="toc_entry_chapter" href="#/9781459271517_c01"><span>Chapter <strong class="b">One</strong></span></a><br/>
<span class="toc_entry_chapter" href="#/9781459271517_c02" title="Link target outside of Sample"><span>Chapter <strong class="b">Two</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459271517_c03" title="Link target outside of Sample"><span>Chapter <strong class="b">Three</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459271517_c04" title="Link target outside of Sample"><span>Chapter <strong class="b">Four</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459271517_c05" title="Link target outside of Sample"><span>Chapter <strong class="b">Five</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459271517_c06" title="Link target outside of Sample"><span>Chapter <strong class="b">Six</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459271517_c07" title="Link target outside of Sample"><span>Chapter <strong class="b">Seven</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459271517_c08" title="Link target outside of Sample"><span>Chapter <strong class="b">Eight</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459271517_c09" title="Link target outside of Sample"><span>Chapter <strong class="b">Nine</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459271517_c10" title="Link target outside of Sample"><span>Chapter <strong class="b">Ten</strong></span></span><br/>
<span class="toc_entry_backMatter" href="#/9781459271517_bm01" title="Link target outside of Sample"><span><strong class="b">Epilogue</strong></span></span><br/>
<span class="toc_entry_pubInfo" href="#/9781459271517_cop01" title="Link target outside of Sample"><span>Copyright</span></span><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459271517_toc01.vue?257ca89e